import React, {FC} from 'react';

interface ProductCardProps {
    thumbnail?: any;
    name: any;
    color: any;
    price?: any;
    quantity?: any;
    content?: any;
    unavailableMileage?: any;
    unavailableCoupon?: any;
}

export const MProductCard: FC<ProductCardProps> = ({
                                                       thumbnail,
                                                       name,
                                                       color,
                                                       price,
                                                       quantity,
                                                       content,
                                                       unavailableMileage,
                                                       unavailableCoupon,

                                                   }) => {
    return (
        <>
            <div className="flex space-x-4 font-normal items-center m-3">
                <div className="w-20 h-28 relative rounded-md overflow-hidden">
                    <img
                        src={thumbnail}
                        alt=""
                        className="w-full h-full object-cover absolute"
                    />
                </div>
                <div className="space-y-2 text-10 font-semibold">
                    <p className="whitespace-normal">
                        {name}
                        <br/>
                        <span className="text-brand-3">{color}</span>
                    </p>

                    {price && quantity && (
                        <p className="text-brand-3">
                            {price}원/수량{quantity}개
                        </p>
                    )}

                    {content}
                    {unavailableMileage && (
                        <p className="text-14 text-red-500" style={{fontSize:'4px'}}>
                            적립금 사용/적립 불가 상품
                        </p>
                    )}
                    {unavailableCoupon && (
                        <p className="text-14 text-red-500" style={{fontSize:'4px'}}>
                            쿠폰 사용 불가 상품
                        </p>
                    )}
                </div>
            </div>
        </>
    );
};
